import { jsxs as o, jsx as l } from "react/jsx-runtime";
const i = (r) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...r,
    children: [
      /* @__PURE__ */ l("path", { fill: "currentColor", d: "M42 6v4h12v44l4-1.07V6H42Z" }),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m49.8 49.82.06-12.79L20.31 7.49 7.47 20.34l29.55 29.54 12.78-.06Zm-3.95-11.13L45.83 44l-1.85 1.85-5.31.02-1.35-1.35 7.19-7.19 1.34 1.36ZM13.13 20.34l7.19-7.19 3.13 3.13-7.19 7.19-3.13-3.13Zm4.54 4.54 7.19-7.19 18.23 18.23-7.19 7.19-18.23-18.23Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m22.921 24.3-1.414 1.415 13.958 13.958 1.414-1.414L22.921 24.3ZM25.638 21.575l-1.414 1.415 13.958 13.958 1.414-1.415-13.958-13.958ZM54 54H12c-1.1 0-2-.9-2-2V42H6v10c0 3.31 2.69 6 6 6h43.07L54 54Z"
        }
      )
    ]
  }
);
export {
  i as Edit
};
